module.exports = __webpack_public_path__ + "static/media/download.79c94224.svg";